import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import CompactSingleSelects from 'components/search/CompactSingleSelects';

import css from 'styles/components/search/desktopSearchMenu.scss';

export class DesktopSearchMenu extends Component {
  static displayName = 'DesktopSearchMenu';

  constructor(props) {
    super(props);
    this.shouldRenderSelections = this.shouldRenderSelections.bind(this);
  }

  makeSelections() {
    const { filters, handlePillClick, removePersonalizedSize } = this.props;
    const { router } = this.context;
    let selections = null;
    if (this.shouldRenderSelections()) {
      selections = <CompactSingleSelects
        // The key below ensures this component re-renders each time a page is navigated,
        // Forcing pill state in search to reset to the left
        key={router.location.pathname}
        filters={filters}
        handlePillClick={handlePillClick}
        removePersonalizedSize={removePersonalizedSize}
        hasAutoScroll={true}/>;
    } else {
      return null;
    }

    return (
      <div className={css.selections} id="searchSelectedFilters">
        {selections}
      </div>
    );
  }

  shouldRenderSelections() {
    const { filters } = this.props;
    const { singleSelects, multiSelects } = filters.selected;

    return Object.keys(singleSelects).length > 0 || (multiSelects.brandId ? Object.keys(multiSelects).length > 1 : Object.keys(multiSelects).length > 0);
  }

  render() {
    return (
      <div className={cn(css.desktopSearchMenu, css.pillsDesktopSearchMenu)}>
        {this.makeSelections()}
      </div>
    );
  }
}

DesktopSearchMenu.propTypes = {
  selectedLayout: PropTypes.string,
  filters: PropTypes.object,
  facets: PropTypes.object
};

DesktopSearchMenu.contextTypes = {
  testId: PropTypes.func,
  router: PropTypes.object
};

export default withErrorBoundary('DesktopSearchMenu', DesktopSearchMenu);
